"use client"

import { isDiscountActive, getDiscountPercentage } from "@/lib/utils"

interface DiscountBadgeProps {
  className?: string
}

export default function DiscountBadge({ className = "" }: DiscountBadgeProps) {
  const isActive = isDiscountActive()
  const discountPercentage = getDiscountPercentage()

  if (!isActive || discountPercentage <= 0) {
    return null
  }

  return (
    <div className={`absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-md z-10 ${className}`}>
      -{discountPercentage}% OFF
    </div>
  )
}
